import request from '@/utils/request'
import Utils from '@/utils/util'

let wConfig = Utils.getConfig()

function generateRequest(data, obj, variable) {
    let new_data = data
    if (obj.param) {
        new_data = Object.assign(obj.param, data)
    }
    let baseUrl = obj.baseURL || wConfig.VUE_APP_BASE_API
    baseUrl = baseUrl.startsWith('http') ? baseUrl : window.location.protocol + '//' + baseUrl
    return request({
        url: obj.url || '',
        method: obj.method || 'post',
        responseType: obj.responseType || 'json',
        baseURL: baseUrl,
        apiType: obj.apiType || '',
        data: new_data,
        ...variable
    })
}

class GenerateAPI {
    static generate(config) {
        let api_obj = {}
        let keys = Object.keys(config)
        keys.forEach(x => {
            api_obj[x] = (data, variable) => {
                let obj = config[x]
                return generateRequest(data, obj, variable)
            }
        })
        return api_obj
    }
}

export default GenerateAPI
